<template>
	<div
		class="ms-grid-viewer ms-tree-viewer"
		:class="[
			browserInfo && browserInfo.isFirefox ? 'overflow-auto' : '',
			{ 'is-empty': isNoData },
		]"
	>
		<table class="ms-table">
			<thead
				class="ms-thead"
				:class="[
					{
						'ms-thead-firefox': browserInfo && browserInfo.isFirefox,
					},
				]"
			>
				<tr class="ms-tr">
					<ms-th
						v-for="(col, index) in columnx"
						:key="index"
						:col="col"
						class="ms-th"
					></ms-th>
				</tr>
			</thead>
			<tbody
				ref="content"
				v-if="dataView.length > 0 && !isNoData"
				:class="[
					{ 'overflow-y-auto': browserInfo && browserInfo.isFirefox },
					hasScroll ? 'ms-content--table--scroll' : '',
					isHideLastRowBorderOnScroll ? 'hide-border-last-row-on-scroll' : '',
				]"
			>
				<ms-tr
					v-for="(row, indexRow) in dataView"
					:key="`${indexRow}-${row.isHide}`"
					:dataRow="row"
					:columns="columnx"
					:isShowExpanded="isShowExpanded"
					:rowActions="rowActions"
					:rowActionsWidget="rowActionsWidget"
					v-on="listeners"
					@dataAction="handlerAction"
					:class="[
						dataView && indexRow == dataView.length - 1 ? 'ms-tr-last' : '',
					]"
				></ms-tr>
			</tbody>
		</table>
		<div v-if="isNoData" class="text-center h-full flex-box justify-center">
			<ms-no-data
				:noDataSlot="noDataSlot"
				:options="getFilterEmptyOptions"
				:isScreenMall="isScreenMall"
			>
				<template #noData>
					<slot name="noData"></slot>
				</template>
			</ms-no-data>
		</div>
	</div>
</template>
<script>
import msTr from './msTr.vue';
import msTh from './msTh.vue';
import browserInfoMixin from '@/mixins/common/browserInfoMixin';
export default {
	mixins: [browserInfoMixin],
	name: 'msTreeViewer',
	components: {
		msTr,
		msTh,
	},
	props: {
		data: {
			type: Array,
			default: () => [],
		},

		//Cấu hình các cột truyền vào
		columns: {
			type: Array,
			default: () => [],
		},
		isShowExpanded: {
			type: Boolean,
			default: true,
		},
		/**
		 * Hiển thị slot noData tùy chỉnh từ ngoài thay vì UI mặc định
		 */
		noDataSlot: {
			type: Boolean,
			default: false,
		},
		/**
		 * Cấu hình tùy chỉnh UI khi không có dữ liệu
		 * isShowEmptyData: hiển thị icon empty-data (chưa từng có dữ liệu) thay vì icon search-not-found
		 * title/subTitle: text tùy chỉnh
		 * disableTitle/disableSubTitle: ẩn title/subTitle
		 * titleClass/subTitleClass: class tùy chỉnh
		 */
		filterEmptyOptions: {},
		/**
		 * Cấu hình các tuỳ chọn chung của cây, giống hệt gridOptions của msGridViewer
		 * @params rowActions Danh sách action hiển thị nổi lên (overlay) khi hover vào dòng
		 * @params rowActionsWidget Component widget tùy chỉnh render vào overlay, ưu tiên hơn rowActions nếu truyền cả hai
		 */
		gridOptions: {},
	},
	created() {
		const me = this;
		me.initColumns();
		me.initData();
	},
	computed: {
		dataView() {
			const me = this;
			return me.datax.filter((item) => {
				return item.isHide == false;
			});
		},

		/**
		 * Sự kiện từ 1 dòng dữ liệu emit ra ngoài
		 */
		listeners() {
			const me = this;
			return {
				click: (dataRow, event) => {
					event.target.focus();
					me.$emit('click', dataRow, event);
				},
				dblclick: (dataRow, event) => {
					me.$emit('dblclick', dataRow, event);
				},
				widgetEvent: (data, event) => {
					me.$emit('widgetEvent', data, event);
				},
				rowAction: (data) => {
					me.$emit('rowAction', data);
				},
			};
		},
		getFilterEmptyOptions() {
			const me = this;
			if (!me.filterEmptyOptions) return {};
			return me.filterEmptyOptions;
		},
		/**
		 * Danh sách action hiển thị nổi lên (overlay icon) ở cột cuối cùng khi hover vào dòng
		 * Truyền qua gridOptions.rowActions, giống hệt cơ chế của msGridViewer
		 */
		rowActions() {
			const me = this;
			return (me.gridOptions && me.gridOptions.rowActions) || null;
		},
		/**
		 * Component widget tùy chỉnh render vào overlay ở cột cuối cùng khi hover, thay cho rowActions
		 * Truyền qua gridOptions.rowActionsWidget
		 */
		rowActionsWidget() {
			const me = this;
			return (me.gridOptions && me.gridOptions.rowActionsWidget) || null;
		},
		/**
		 * Chỉ bỏ border-bottom dòng cuối khi grid đang có scroll dọc VÀ cha cho phép qua props gridOptions
		 */
		isHideLastRowBorderOnScroll() {
			const me = this;
			return (
				me.hasScroll &&
				me.gridOptions &&
				me.gridOptions.hideLastRowBorderOnScroll
			);
		},
	},
	watch: {
		columns: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.initColumns();
			},
		},
		data: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.checkHasScroll();
				if (
					newVal.length <= 0 ||
					(newVal.length > 0 && newVal.every((x) => x.isHide === true))
				) {
					me.isNoData = true;
				} else {
					me.isNoData = false;
				}

				// Nếu props data truyền vào thay đổi thì datax cũng phải thay đổi theo
				if (me.datax !== me.data) {
					me.initData(newVal);
				}
			},
		},

		isScreenMall: {
			handler(newVal, oldVal) {
				const me = this;
				me.isScreenMall = me.$ms.commonFunc.checkSmallScreen();
			},
		},
	},
	mouted() {
		const me = this;
		me.$nextTick(() => {
			me.checkHasScroll();
		});
	},
	data() {
		return {
			columnx: [],
			datax: [],
			isNoData: true,
			isScreenMall: this.$ms.commonFunc.checkSmallScreen(),
			hasScroll: false,
		};
	},
	methods: {
		/**
		 * Khởi tạo dữ liệu ban đầu cho grid
		 * columns truyền vào mặc định là columns trong props có thể truyền cấu hình khác từ ngoài vào
		 */
		initColumns(columns = this.columns) {
			const me = this;
			me.columnx = columns ? columns : me.columns;
			if (!me.columnx) {
				me.columnx = [];
			}
		},
		initData(data = this.data) {
			const me = this;
			me.isNoData = false;
			me.datax = data;
		},
		handlerAction(data) {
			const me = this;
			me.$emit('dataAction', data);
		},
		checkHasScroll() {
			const me = this;
			me.$nextTick(() => {
				if (me.$refs.content) {
					if (
						me.$refs.content.getBoundingClientRect().height + 2 <
						me.$refs.content.scrollHeight
					) {
						me.hasScroll = true;
					} else {
						me.hasScroll = false;
					}
				}
			});
		},
	},
};
</script>
<style lang="scss">
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msGridViewer.scss';
	.ms-tree-viewer {
		overflow: auto;
	}
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msGridViewer.scss';
}
.ms-tree-viewer {
	height: 100%;
	padding-left: 16px;
	table {
		height: 100%;
		tbody {
			display: block;
			overflow-y: scroll;
			height: calc(100% - 32px);
		}
		thead,
		tbody tr {
			display: table;
			width: 100%;
			table-layout: fixed;
		}
		thead {
			width: calc(100% - 16px);
		}
	}

	/* Khi rỗng: table chỉ giữ chiều cao header (không ép 100%), phần noData chiếm hết chỗ còn lại */
	&.is-empty {
		display: flex;
		flex-direction: column;

		table {
			height: auto;
			flex-shrink: 0;
		}

		> .flex-box {
			flex: 1;
			min-height: 0;
		}
	}
}
.no-data {
	text-align: center;
	font-size: 16px;
	padding: 10px 0;
}

.ms-thead-firefox {
	position: sticky;
	top: 0;
	z-index: 1;
	width: 100% !important;
}

@media screen and (max-width: 1024px) {
	.ms-tree-viewer {
		overflow: auto;
	}
}
</style>